import { useEffect, useState } from 'react';
import VerificationInput from 'react-verification-input';
import classNames from 'classnames';

interface UserTokenVerificationProps {
  disabled?: boolean;
  onChange?: (token: string) => void;
  onSubmit: (token: string) => void;
}

export default function UserTokenVerification({
  disabled = false,
  onChange,
  onSubmit,
}: UserTokenVerificationProps) {
  const [token, setToken] = useState('');

  useEffect(() => {
    if (token.length === 6) {
      onSubmit(token);
      setToken('');
    }
  }, [token, onSubmit]);

  const handleChange = (token: string) => {
    setToken(token);
    if (onChange) {
      onChange(token);
    }
  };

  return (
    <VerificationInput
      containerProps={{
        style: {
          width: '100%', // force full available width
        },
      }}
      inputProps={{
        inputMode: 'numeric', // force num keypad
        disabled: disabled,
      }}
      classNames={{
        container: 'h-16 gap-4',
        character:
          'bg-white border-slate-300 rounded-md flex justify-center items-center font-avenir-black text-base 3xs:text-lg text-navy-blue',
        characterInactive: 'text-slate-300 border-slate-600',
        characterSelected: classNames({
          'outline-none': disabled,
          'outline-primary-blue': !disabled,
        }),
      }}
      autoFocus={true}
      placeholder="-"
      validChars="0-9"
      length={6}
      value={token}
      onChange={handleChange}
    />
  );
}
